import { Button, DropDownButton } from '@progress/kendo-react-buttons'
import { process } from '@progress/kendo-data-query';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools'
import { format } from 'date-fns'
import { CSVLink } from 'react-csv'
import { get, post, setCoordenadasSelected, setIsEditingOcorrencia, setIntervencaoSelected, setOcorrenciaSelected, handleGenericError, hasPermission, ocEstados, handleDownload, exportPDFWithMethod, b64toBlob, GetUserNameTecnico, updateColumnsGrid, exportToCSV, searchLimit } from '../../services/utils'
import { useOcorrenciaStore } from '../../stores/ocorrencias'
import {
  AUTH_LOCALSTORAGE,
  CURRENT_TIMEZONE,
  EPSG_MAP,
  EPSG_OCORRENCIA_DISPLAY,
  GET_DOCUMENTO,
  GET_EMAIL_BY_USER_ID,
  GET_OCORRENCIA,
  GET_OCORRENCIAS_SHAPEFILE,
  GET_USER_BY_ID,
  LAYER_INDEX_OCORRENCIAS,
  LAYER_INDEX_OCORRENCIA_APOIO,
  OCORRENCIA_POINT_NAME,
  OPERATIONAL_LAYER,
  PERMISSION_CONSULTAR_OCORRENCIA,
  PERMISSION_DOCUMENTOS_CONSULTA_AVANCADA,
  PERMISSION_INSERIR_OCORRENCIA,
  PERMISSION_OCORRENCIA_PERFIL_COMPLETO_EDICAO,
  PERMISSION_OCORRENCIA_PERFIL_COMPLETO_LEITURA,
  PERMISSION_OCORRENCIA_PERFIL_INTERMEDIO_EDICAO,
  PERMISSION_OCORRENCIA_PERFIL_INTERMEDIO_LEITURA,
  PERMISSION_OCORRENCIA_PERFIL_TOTAL,
  PESQUISAR_DOCUMENTOS_BY_OCORRENCIAS,
  PESQUISAR_OCORRENCIAS_AVANCADA,
  PESQUISAR_OCORRENCIAS_AVANCADA_TO_EXPORT,
  PESQUISAR_OCORRENCIAS_LIST_RESULTS,
  PESQUISAR_OCORRENCIAS_SIMPLES,
  PROJECTION_OCORRENCIA_DISPLAY,
  RDLC_RESULTADOS_OCORRENCIA,
  RECORDS_LIMIT,
  RELATORIO_MERGE,
  URL_AJUDA_OCORRENCIA_PESQUISA_AVANCADA,
  URL_AJUDA_OCORRENCIA_PESQUISA_SIMPLES,
} from '../../utils/constants'
import { ResultadoOcorrenciaCommandGridCell } from './ResultadoOcorrenciaCommandGridCell'


import styles from '../../styles/ocorrencia/OcorrenciasStylesv2.module.scss'
import commonStyles from '../../styles/common/Common.module.scss'

import {
  Dispatch,
  MouseEvent as ReactMouseEvent,
  SetStateAction,
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
  useRef
} from 'react'

import {
  Grid,
  GridCellProps,
  GridColumn,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuFilter,
  GridColumnMenuGroup,
  GridColumnMenuProps,
  GridColumnMenuSort,
  GridPageChangeEvent,
  GridToolbar,
} from '@progress/kendo-react-grid'

import {
  TabStrip,
  TabStripSelectEventArguments,
  TabStripTab,
} from '@progress/kendo-react-layout'
import SessionStorageService from '../../services/SessionStorageService'
import CustomGridCell from './CustomGridCell'
import { useCommonStore } from '../../stores/common'
import clsx from 'clsx'
import MaximizeButton from '../common/MaximizeButton'
import { ResultadoDocumentoCommandGridCell } from '../documentos/ResultadoDocumentoCommandGridCell'
import { Dialog } from '@progress/kendo-react-dialogs'
import ImagePreviewV2 from '../viewer/ImagePreviewV2'
import VisualizadorColunas from '../Generico/VisualizadorColunas '
import useVisibleColumns, { Key } from '../../hooks/useVIsibleColumns'
import React from 'react';
import ReactGA from 'react-ga4';
import { elementoClickMais, itemRenderMais, mostraFloatingMenu_e_Mapa, ocultaFloatingMenu_e_Mapa, telaMobile } from '../common/ItemRenderMais'
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { GridPDFExport } from '@progress/kendo-react-pdf';
import moment from 'moment';
import "moment-timezone"
import proj4 from 'proj4';
import { base64ApaImage, base64FooterImages, base64SiarlImage } from '../../routes/Base64Images';
let ocorrenciasDataFilter : any = [];
let selectTab : any = 0;
let documentosOcorrenciasFilter : any = [];
type Props = {
  onCloseClick: () => void | undefined
  setShowResults: Dispatch<SetStateAction<boolean>>
  setShowOcorrenciaForm?: Dispatch<SetStateAction<boolean>>
}

type PageState = {
  skip: number
  take: number
}
type PageState2 = {
  skip: number
  take: number
}
type SortState = {
  sort: []
}
type SortStateDocumentos = {
  sort: []
}
const initialDataState: PageState = { skip: 0, take: 20 }
const initialDataState2: PageState = { skip: 0, take: 20 }
const keyPainelPrincipal:Key = 'ocorrenciaColunasVisiveis';
const inicialSortState : SortState = {sort : []}
const inicialSortStateDocumentos : SortStateDocumentos = {sort : []}
const keyPainelDocumentos:Key = 'ocorrenciaDocumentosColunasVisiveis';
export default function ResultadoOcorrenciaForm({
  onCloseClick,
  setShowResults,
  setShowOcorrenciaForm,
}: Props) {
  const [isMobile, setIsMobile] = useState(false);
  const [page, setPage] = useState<PageState>(initialDataState)
  const [page2, setPage2] = useState<PageState>(initialDataState2)
  const [sort, setsort] = useState<SortState>(inicialSortState)
  const [sortDocumentos, setsortDocumentos] = useState<SortStateDocumentos>(inicialSortStateDocumentos)
  const [pageSizeValue, setPageSizeValue] = useState<
    number | string | undefined
  >()
  const [ocorrencias, setOcorrencias] = useState([])
  const [documentosOcorrencias, setDocumentosOcorrencias] = useState([])
  const selectOcorrenciaResult = useOcorrenciaStore(
    (state) => state.selectOcorrenciaResult
  )
  const selectOcorrenciaResultId = useOcorrenciaStore(
    (state) => state.selectOcorrenciaResultId
  )

  const [openFormViewDocumento, setOpenFormViewDocumento] = useState<boolean>(false)
  const [documentos, setDocumentos] = useState([])
  const [urlDoDocumento, setUrlDoDocumento] = useState("");
  const [idDoDocumento, setIdDoDocumento] = useState("");
  const [ocorrenciasFinal, setOcorrenciasFinal] = useState<any>([]);
  const [isSmallerThan1350, setIsSmallerThan1350] = useState(false);
  const [isSmallerThan1120, setIsSmallerThan1120] = useState(false);
  const [isSmallerThan850, setIsSmallerThan850] = useState(false);
  const [showExportButtons, setShowExportButtons] = useState(true);
  const [optionsExportar, setOptionsExportar] = useState<any>();
  const REGISTOS = 0;
  const DOCUMENTOS = 1;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [pageable, setPageable] = useState<any>({
    buttonCount: 5,
    info: true,
    type: 'numeric',
    pageSizes: true,
    previousNext: true,
  })

  
  const getEmailByUserId = async (data: any) =>
    await get<any, any>(`${GET_EMAIL_BY_USER_ID}/` + data)

    
  const relatorioResultadosPesquisa = async (data: any) =>
    await post<any, any>(`${RDLC_RESULTADOS_OCORRENCIA}`, data)


  const getOcorrencias = async (data: any) =>
  await post<any, any>(`${PESQUISAR_OCORRENCIAS_AVANCADA}`, data)
  const getOcorrenciasToExport = async (data: any) =>
    await post<any, any>(`${PESQUISAR_OCORRENCIAS_AVANCADA_TO_EXPORT}`, data)
  
  const getOcorrenciasSimples = async (data: any) =>
  await post<any, any>(`${PESQUISAR_OCORRENCIAS_SIMPLES}`, data)

  const getShapeFile = async (data: any) =>
  await post<any, any>(`${GET_OCORRENCIAS_SHAPEFILE}`, data)
  
  const isCurrentViewMaximized = useCommonStore(state => state.isCurrentViewMaximized)

  const restoreView = useCommonStore(state => state.restoreView)
  
  const getOcorrenciasPorIds = async (data: any) =>
    await post<any, any>(`${PESQUISAR_OCORRENCIAS_LIST_RESULTS}`, data) 

  const relatorioOcorrenciasMerge = async (data: any) =>
    await post<any, any>(`${RELATORIO_MERGE}`, data)

  const getDocumentosByOcorrencias = async (data: any) =>
    await post<any, any>(`${PESQUISAR_DOCUMENTOS_BY_OCORRENCIAS}`, data)
  const [openForm, setOpenForm] = useState<boolean>(false)

  const getOcorrencia = async (data: any) =>
    await get<any, any>(`${GET_OCORRENCIA}/` + data)

  const getDocumento = async (data: any) =>
    await get<any, any>(`${GET_DOCUMENTO}/` + data)
  
  const getUserById = async (data: any) =>
  await get<any, any>(`${GET_USER_BY_ID}/` + data)

  const handleMessageEvent = useCallback((event: MessageEvent) => {
    if (event.data.type == "resultadoOcorrenciasPesquisaChange") {
      SessionStorageService.setItem("resultadoOcorrenciasPesquisa", event.data.value);
    }
  }, [])

    const [dataState, setDataState] = React.useState({
    skip: 0,
    take: 20,
    sort: [],
    group: [],
  });

  const [dataStateDocumentos, setDataStateDocumentos] = React.useState({
    skip: 0,
    take: 20,
    sort: [],
    group: [],
  });

  const selectedOcorrenciaResult: any = useOcorrenciaStore(
    (state) => state.selectedOcorrenciaResult
  )
  
    const dataStateChangeDocumentos = (event: any) => {
    setDataResultDocumentos(process(documentosOcorrencias, event.dataState));
    const skip2: PageState = { skip: event.dataState.skip, take: event.dataState.take}
  
    setPage({
      ...skip2
    })

    const sortable: SortStateDocumentos = { sort: event.dataState.sort}
    
    setsortDocumentos({...sortable})

    
    //setDataStateDocumentos(event.dataState);
  };

  useEffect(() => {
    if (hasPermission(PERMISSION_OCORRENCIA_PERFIL_TOTAL)) {
      setOptionsExportar(optionsExportarPerfilTotal);
    } else {
      setOptionsExportar(optionsExportarNormal);
    }
  }, [])

  const [dataResultDocumentos, setDataResultDocumentos] = React.useState(
    process(documentos, dataStateDocumentos)
  );

  const dataStateChange = (event: any) => {
    setDataResult(process(ocorrencias, event.dataState));
    const skip2: PageState2 = { skip: event.dataState.skip, take: event.dataState.take}
    setPage2({
      ...skip2
    })
    const sortable: SortState = { sort: event.dataState.sort}
    
    setsort({...sortable})
    //setDataState(event.dataState);
    
  };

   const [dataResult, setDataResult] = React.useState(
    process(ocorrencias, dataState)
  );

  const [percentLeftMsg, setPercentMsg] = useState("19%");

  useEffect(() => {
    ocorrenciasDataFilter = dataResult.data;
  }, [dataResult])

  useEffect(() => {
    documentosOcorrenciasFilter = dataResultDocumentos.data;
  }, [dataResultDocumentos])

  useEffect(() => {
    window.addEventListener(
      'message',
      handleMessageEvent,
      false
    )

    return () => {
      window.removeEventListener(
        'message',
        handleMessageEvent,
        false
      )
    }
  }, [handleMessageEvent])

  const initialized = useRef(false)
  useEffect(() => {
      if (!initialized.current) {
        initialized.current = true;
      
      if (SessionStorageService.getItem("lastSearchOcorrenciasAvancada") && !SessionStorageService.getItem("firstCallOcorrencias")) {
        
        setTimeout(() => {
          const objToSearch = SessionStorageService.getItem("lastSearchOcorrenciasAvancada") ?? '';
          getOcorrencias(objToSearch).then((data) => {
            SessionStorageService.setItem("resultadoOcorrenciasPesquisa", JSON.stringify(data));
            setResultsOcorrencia();
          })},
          1000);
        } else if (SessionStorageService.getItem("lastSearchOcorrencias") && !SessionStorageService.getItem("firstCallOcorrencias")) {
          setTimeout(() => {
          const objToSearch = SessionStorageService.getItem("lastSearchOcorrencias") ?? '';
          getOcorrenciasSimples(objToSearch).then((data) => {
            SessionStorageService.setItem("resultadoOcorrenciasPesquisa", JSON.stringify(data));
            setResultsOcorrencia();
          });},
          1000);
      }
      else {
      setResultsOcorrencia();
    }
  }
  }, [])

  proj4.defs(EPSG_OCORRENCIA_DISPLAY, PROJECTION_OCORRENCIA_DISPLAY);

  const setResultsOcorrencia = () => {
    const results = JSON.parse(
      SessionStorageService.getItem('resultadoOcorrenciasPesquisa') ?? ''
    )

    const formattedResults = results.map((ocorrencia: any) => {
      const dataOcorrencia = ocorrencia.data_ocorrencia ? new Date(ocorrencia.data_ocorrencia + 'Z').toLocaleString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }) : 'Data indeterminada';
      const dataRegisto = new Date(ocorrencia.data_registo + 'Z').toLocaleString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });

      let localizacao_concat = '';
      if (ocorrencia.praia) {
        localizacao_concat = ocorrencia.praia + ', ' + ocorrencia.concelho
      } else if (ocorrencia.ref_localizacao) 
      {
        localizacao_concat = ocorrencia.ref_localizacao + ' - ' + ocorrencia.concelho
      } else {
        localizacao_concat = ocorrencia?.concelho;
      }
      let latitude;
      let longitude;
      if (ocorrencia.coord_x &&  ocorrencia.coord_y) {
      const latLong = proj4(EPSG_MAP, EPSG_OCORRENCIA_DISPLAY, [ocorrencia.coord_x,ocorrencia.coord_y]);
        if (latLong && latLong.length > 0) {
          longitude= latLong[0].toFixed(0);
          latitude = latLong[1].toFixed(0);
        }
      }
      return {
        ...ocorrencia,
        localizacao_concat: localizacao_concat,
        data_ocorrencia: dataOcorrencia,
        data_registo: dataRegisto,
        latitude: latitude,
        longitude: longitude
      };
    });

    if (results) {
      const iframe: any = document.getElementById('iframeGeoPortal')
      const ids: number[] = []
      const idsApoio: number[] = []
      results.forEach((element: any) => {
        ids.push(element.id)
      })
      if (columns) {
      iframe.contentWindow?.postMessage(
        { type: 'SiarlDefineExtraLayerTooltipColumns', value:
          { layer: OCORRENCIA_POINT_NAME,  columns: columns?.columns?.filter((x: { show: any; }) => x.show).map((option: { field: any; title: any; }) => ({
       field: option.field,
       title: option.title
     })) } },
        '*'
      )
    }
      iframe.contentWindow?.postMessage(
        { type: 'SiarlOcorrenciasSearch', value: {ids: ids, result: formattedResults,} },
        '*'
      )

      // console.log(columns.columns.map((option: { field: any; title: any; }) => ({
      //   field: option.field,
      //   title: option.title
      // })))
      
    }
    
    sessionStorage.removeItem('sistemasNaturais')
    sessionStorage.removeItem('pessoaEmRisco')
    sessionStorage.removeItem('medidasMetigacao')
    sessionStorage.removeItem('detecaoOcorrencia')
    sessionStorage.removeItem('highlightClicked')
    ocorrenciasDataFilter = formattedResults;
    setOcorrencias(formattedResults);
    setOcorrenciasFinal(formattedResults.slice(page2.skip, page2.take + page2.skip)) 
  
    postMessage({ type: 'hideLoader' }, '*');

    try {
      const idsOcorrencias = results.map((o: any) => o.id)
      getDocumentosByOcorrencias(idsOcorrencias).then(response => {
        setDocumentosOcorrencias(response.map((item: any) => ({
          ...item,
          hasGeom: true,
          data_registo: moment.utc(item.data_registo).tz(CURRENT_TIMEZONE).format("DD/MM/yyyy HH:mm")
        })))
        documentosOcorrenciasFilter = (response.map((item: any) => ({
          ...item,
          data_registo: moment.utc(item.data_registo).tz(CURRENT_TIMEZONE).format("DD/MM/yyyy HH:mm")
        })))
        console.log(response)
      })

    } catch (error) {
      console.error('Erro ao buscar os dados:', error)
    }
  }

  useEffect(() => {
    const iframe: any = document.getElementById('iframeGeoPortal')
    const ids: number[] = []
    ocorrencias.forEach((element: any) => {
      ids.push(element.id)
    })
    iframe.contentWindow?.postMessage(
      { type: 'SiarlOcorrenciasSearch', value: ids },
      '*'
    )
  }, [])

  const openPdfNewTab = async () => {
    try {
      const relatorios = [];
      const parameters : any = {}; 

      let valoresOcorrenciasStored = SessionStorageService.getItem('resultadoOcorrenciasPesquisa');
      valoresOcorrenciasStored = JSON.parse(valoresOcorrenciasStored);
      postMessage({ type: 'showLoader' }, '*');

      console.log(valoresOcorrenciasStored)


      
      for (const resultado of valoresOcorrenciasStored) {

        
      let localizacao_concat = '';
      if (resultado.praia) {
        localizacao_concat = resultado.praia + ', ' + resultado.concelho
      } else if (resultado.ref_localizacao) 
      {
        localizacao_concat = resultado.ref_localizacao + ' - ' + resultado.concelho
      } else {
        localizacao_concat = resultado?.concelho;
      }
      let latitude = 0;
          let longitude = 0;
        if (resultado.coord_x && resultado.coord_y) {
          const latLong = proj4(EPSG_MAP, EPSG_OCORRENCIA_DISPLAY, [resultado.coord_x,resultado.coord_y]);
    
          if (latLong && latLong.length > 0) {
            longitude= latLong[0].toFixed(0);
            latitude = latLong[1].toFixed(0);
          }
        }

        const relatorio = {
            id: resultado.id,
            dados: {
                'Data ocorrencia': resultado?.data_ocorrencia ? new Date(resultado?.data_ocorrencia).toLocaleDateString() : 'Data indeterminada',
                'Data registo': resultado?.data_registo ? new Date(resultado?.data_registo).toLocaleDateString() : '',
                'N Processo APA': resultado?.filedoc_cod ?? '',
                'Localizacao': localizacao_concat ?? '',
                'Tipologia': resultado?.tipologia ?? '',
                'Consequencias': resultado?.consequencias ?? '',
                'Entidade': resultado?.entidade ?? '',
                'Tecnico': resultado?.tecnico ?? '',
                'Nuts1': resultado?.nuts1 ?? '',
                'Nuts2': resultado?.nuts2 ?? '',
                'Nuts3': resultado?.nuts3 ?? '',
                'Distrito': resultado?.distrito ?? '',
                'Concelho': resultado?.concelho ?? '',
                'Freguesia': resultado?.freguesia ?? '',
                'Arh': resultado?.arh ?? '',
                'Massa agua': resultado?.massaAgua ?? '',
                'Praia': resultado?.praia ?? '',


                'Tipo detecao': resultado?.designacao_tipo_detecao ?? '',
                'Estado': resultado?.estado_ocorrencia ?? '',
                'Movimento de massa de vertente (MMV)': resultado?.descricao_tip_mmv ?? '',
                'Fenda de tração com abertura visível': resultado?.tip_fenda_visivel_descricao ?? '',
                'Erosão/recuo da linha da costa': resultado?.tip_erosao_arribas_descricao ?? '',
                'Escarpamento da duna': resultado?.tip_escarpamento_duna_descricao ?? '',
                'Rebaixamento da praia': resultado?.tip_rebaixamento_praia_descricao ?? '',
                'Instabilidade em arribas': resultado?.inst_arribas ?? '',
                'Galgamento costeiro': resultado?.galgamento_costeiro_descr ?? '',
                'Danos em estruturas de proteção/defesa costeira': resultado?.dano_obra ?? '',
                'Estrutura aderente': resultado?.dano_estrutura_aderente ?? '',
                'Esporão/Quebra-Mar': resultado?.dano_esporao ?? '',
                'Estrutura de proteção/estabilização de arriba': resultado?.dano_estrutura_protecao ?? '',
                'Alcance máximo do depósito/detriros (m)': resultado?.alcance_mmv ?? '',
                'Altura máxima da escarpa (m)': resultado?.alcance_escarpamento_duna ?? '',
                'Altura máxima (m)': resultado?.alcance_rebaixamento_praia ?? '',
                'Alcance máximo de água/detritros (m)': resultado?.alcance_galgamento_costeiro ?? '',
                'Pessoas em risco': resultado?.tipo_pessoas_risco_descricao ?? '',
                'Número de pessoas em risco': resultado?.num_pessoas_em_risco ?? '',
                'Danos em áreas construídas de fruição/uso público': resultado?.conseq_danos_areas_construidas_descricao ?? '',
                'Danos em Edificações': resultado?.danos_edificacoes_descricao ?? '',
                'Outros Danos': resultado?.conseq_danos_outras_descricao ?? '',
                'Descrição outros danos': resultado?.conseq_danos_outras_obs ?? '',
                'Danos em sistemas naturais': resultado?.tipo_danos_sistemas_naturais_descricao?? '',
                'Danos em sistemas naturais descrição': resultado?.danos_sistemas_naturais_obs?? '',
                'Causas não sabe/não aplicável': resultado?.causas_nao_sabe_descricao?? '',
                'Causas Tempestade': resultado?.causas_tempestade_descricao?? '',
                'Causas tempestade observações': resultado?.causas_tempestade_obs?? '',
                'Causas sismos': resultado?.causas_sistemos?? '',
                'Causas outras': resultado?.causas_outras?? '',
                'Causas outras descrição': resultado?.causas_ouras_obs?? '',
                'Medidas mitigação de risco': resultado?.tipo_medida_mitigacao_descricao?? '',
                'longitude (ETRS89/PT-TM06)': longitude?? '',
                'latitude (ETRS89/PT-TM06)': latitude?? '',
              
            },
        };

        relatorios.push(relatorio);
    }

    columns.columns.forEach((column : any, index : any) => {
      if (index < 53) {
          const parameterName = `ShowColumn${index + 1}`;
          parameters[parameterName] = !column.show;
      }
  });

    console.log(parameters);

    const requestPayload = {
      relatorios, 
      visibilityParameters: parameters 
    };

    const PdfBase64 = await relatorioResultadosPesquisa(requestPayload);
      if (PdfBase64) {
        const blob = b64toBlob(PdfBase64, 'application/pdf');
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
        postMessage({ type: 'hideLoader' }, '*')
      }
    } catch (error) {
      console.log(error);
      postMessage({ type: 'errorMsg', value: { left: '50%', message: "Verifique os campos obrigatórios." } }, '*');
    } finally {
      postMessage({ type: 'hideLoader' }, '*');
    }
    
};
    
    const downloadPdf =() => {
      return new Promise<void>((resolve, reject) => {
            
        setPageable(false);
        postMessage({ type: "showLoader" }, "*");

        setTimeout(() => {
          const columnsToShow = columns.columns.filter((x: { show: any; }) => x.show);
          const dataToExport = ocorrencias.map((item: any) => {
              const filteredItem: any = {};
              columnsToShow.forEach((column: any) => {
                  filteredItem[column.field] = item[column.field];
              });
              return filteredItem;
          });
          
          exportPDFWithMethod(columnsToShow, dataToExport, 5)
              .then((pdfData: any) => {
                  postMessage({ type: "hideLoader" }, "*");

                      setPageable({
                          buttonCount: 5,
                          info: true,
                          type: 'numeric',
                          pageSizes: true,
                          previousNext: true,
                      });

                        const base64Data = pdfData.split(";base64,")[1];
                        console.log(base64Data);
                        const blob = b64toBlob(base64Data, 'application/pdf');
                        const blobUrl = URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = blobUrl;
                        a.download = `siarl-lista-ocorrencias-${format(new Date(), 'ddMMyyyHHmm')}.pdf`;
                        a.click();
                  
                })
                .catch(error => {
                    console.error('Error exporting PDF:', error);
                    reject(error);
                });
        }, 1000);
    });
    }


  const clearSearchResults = () => {
    SessionStorageService.removeItem('resultadoOcorrenciasPesquisa')
    postMessage({ type: 'resultadoOcorrenciasPesquisaChange' }, '*')
    SessionStorageService.removeItem("lastSearchOcorrenciasAvancada");
    SessionStorageService.removeItem("lastSearchOcorrencias");
    selectOcorrenciaResult(null)
    const iframe: any = document.getElementById('iframeGeoPortal')
    setTimeout(() => {
      iframe.contentWindow?.postMessage(
        { type: 'SiarlOcorrenciasClearLayers', value: 'true' },
        '*'
      )
    }, 2000);
  }

  const handleRowMouseEnterById = (item: Record<string, unknown>) => {
    const id = item.ocorrencia_id ?? item.id;
    const iframe: any = document.getElementById('iframeGeoPortal')
    //iframe.contentWindow?.postMessage({ type: "SiarlOcorrenciasSearch", value: [ocorrencia.id] }, '*')
    if (id) {
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlOcorrenciasHighlight',
            value: [id],
          },
          '*'
        )

    }
  }
  
  const handleRowMouseLeaveById = (item: Record<string, unknown>) => {
    const id = item.ocorrencia_id ?? item.id;
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
      {
        type: 'SiarlOcorrenciasHighlightRemove',
        value: [id],
      },
      '*'
    )
  }

  const handleLocationClickById = (item: Record<string, any>) => () => {
    const iframe: any = document.getElementById('iframeGeoPortal')
    const id = item.ocorrencia_id ?? item.id;
    iframe.contentWindow?.postMessage(
      {
        type: 'SiarlOcorrenciasCenter',
        value: [id],
      },
      '*'
    )
    restoreView();
    
    if(isMobile) onCloseClick()
  }

   const registarNovoClick = async () => {
    setIsEditingOcorrencia(false);
    sessionStorage.setItem('novoPontoOcorrencia', 'true')
    SessionStorageService.setItem("novaOcorrencia", 'true')
    SessionStorageService.setItem('ocorrenciaAntiga', 'false')
    sessionStorage.setItem('ocGeomEdited', 'false')
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
      { type: 'SiarlGeoPortalAdicionarPonto', value: 'true' },
      '*'
    )
    postMessage(
      { type: 'infoMsgMapa',  value: { message: 'Selecione o local no mapa' , left: (isMobile? (Number(percentLeftMsg.split('%')[0])-5)+'%' : '42%') } },
      '*'
    )
    postMessage({type: "closeForms", value: ""}, "*");
    
    restoreView();
  }
  
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/ResultadoOcorrencia" });
  }, []);



  const handleInfoClickById = (item: Record<string, any>) => async () => {
    
    setIsEditingOcorrencia(true);
    const userLocal = JSON.parse(
      localStorage.getItem(AUTH_LOCALSTORAGE) ?? '{}'
    )
    // Se veio da listagem de documentos terá ocorrencia_id
    const id = item.ocorrencia_id ?? item.id;
    const ocorrencia = await getOcorrencia(id);

    const entidadeByUser = ocorrencia?.utilizador?.entidade?.nome;

    if (!ocorrencia) {
      postMessage({type: "infoMsg", value: { message: "Registo desativado" }}, "*");
      return;
    }
    const tecnico = await GetUserNameTecnico(ocorrencia.utilizador_id); 
      
    const seletedOcorrenciaReulst = {
      id: ocorrencia.id,
      // Idetificacao
      distrito: ocorrencia.distrito ?? undefined,
      concelho: ocorrencia.concelho ?? undefined,
      freguesia: ocorrencia.freguesia ?? undefined,
      capitania: ocorrencia.capitania ?? undefined,
      praia: ocorrencia.praia ?? undefined,
      arh: ocorrencia.arh ?? undefined,
      nuts1: ocorrencia.nuts1 ?? undefined,
      nuts2: ocorrencia.nuts2 ?? undefined,
      nuts3: ocorrencia.nuts3 ?? undefined,
      massaAgua: ocorrencia.massa_agua ?? undefined,
      dataHoraRegistro: ocorrencia.data_registo ? moment.utc(ocorrencia.data_registo).tz(CURRENT_TIMEZONE) :undefined ,

      dataHoraOcorrencia: ocorrencia.data_ocorrencia ? moment.utc(ocorrencia.data_ocorrencia).tz(CURRENT_TIMEZONE) : undefined,
      entidade_registo: ocorrencia.entidade?.nome ?? undefined,
      entidade: ocorrencia.entidade ?? undefined,
      observacao: ocorrencia.observacoes ?? undefined,
      tecnico: tecnico,
      detecaoOcorrencia: ocorrencia.tipo_detecao_id ?? undefined,
      // Detalhes
      instabiladeArribas: ocorrencia.tip_inst_arribas ?? undefined,
      movimentoMassa: ocorrencia.tip_mmv ?? undefined,
      tip_mmv_alcance_deposito: ocorrencia.tip_mmv_alcance_deposito ?? undefined,
      fendaTracao: ocorrencia.tip_fenda_visivel ?? undefined,
      erosaoRecuo: ocorrencia.tip_erosao_arribas ?? undefined,
      escarpamento: ocorrencia.tip_escarpamento_duna ?? undefined,
      tip_altura_maxima_escarpa: ocorrencia.tip_altura_maxima_escarpa ?? undefined,
      rebaixamento: ocorrencia.tip_rebaixamento_praia ?? undefined,
      tip_reb_praia_altura_max: ocorrencia.tip_reb_praia_altura_max ?? undefined,
      galgamento: ocorrencia.galgamento_costeiro ?? undefined,
      tip_galg_cost_alcance_max: ocorrencia.tip_galg_cost_alcance_max ?? undefined,
      protecaoDefesa:  ocorrencia.tip_dano_obra ?? undefined,
      estruturaAderente: ocorrencia.tip_dano_estrutura_aderente ?? undefined,
      esporao: ocorrencia.tip_dano_esporao ?? undefined,
      protecaoEstabilizacao: ocorrencia.tip_dano_estrutura_protecao ?? undefined,
      ref_localizacao: ocorrencia.ref_localizacao ?? undefined,
      pessoaEmRisco: ocorrencia.tipo_pessoas_risco_id ?? undefined,
      fruicaoUsoPublico: ocorrencia.conseq_danos_areas_construidas ?? undefined,
      danosEdificacoes: ocorrencia.conseq_danos_edificacoes ?? undefined,
      outrosDanos: ocorrencia.conseq_danos_outras ?? undefined,
      outrosDanosDescricao: ocorrencia.conseq_danos_outras_obs ?? undefined,
      sistemasNaturais: ocorrencia.tipo_danos_sistemas_naturais_id ?? undefined,
      descricaoDanosSistemasNaturais: ocorrencia.danos_sistemas_naturais_obs ?? undefined,
      naoSabe: ocorrencia.causas_nao_sabe ?? undefined,
      tempestade: ocorrencia.causas_tempestade ?? undefined,
      descricaoTempestade: ocorrencia.causas_tempestade_obs ?? undefined,
      sismos: ocorrencia.causas_sistemos ?? undefined,
      outras: ocorrencia.causas_outras ?? undefined,
      descricaoOutras: ocorrencia.causas_ouras_obs ?? undefined,
      medidasMetigacao: ocorrencia.tipo_medida_mitigacao_id ?? undefined,
      sinalizacao: ocorrencia.mitig_sinalizacao ?? undefined,
      delimitacao: ocorrencia.mitig_delimitacao ?? undefined,
      saneamento: ocorrencia.mitig_saneamento ?? undefined,
      reabilitacao: ocorrencia.mitig_reabilitacao ?? undefined,
      reforco: ocorrencia.mitig_reforco ?? undefined,
      // Anexos
      uploadFotografia: ocorrencia.docs_fotos ?? undefined,
      uploadTopografia: '',
      uploadOutro: ocorrencia.docs_outros ?? undefined,
      utilizador_id: ocorrencia.utilizador_id ?? undefined,
      oc_estado: ocorrencia.estado ?? undefined,
      indeterminado: ocorrencia?.data_indeterminada ?? undefined,
      filedoc_cod: ocorrencia?.filedoc_cod ?? undefined,
      oc_ocorrencia_apoio_id: ocorrencia?.oc_ocorrencia_apoio_id,
      numPessoasEmRisco: ocorrencia.num_pessoas_em_risco ?? undefined,
      coord_x: ocorrencia.coord_x,
      coord_y: ocorrencia.coord_y,
      danosEdificacoesOption: ocorrencia.tip_danos_edificacoes ?? undefined,

    }
    const iframe: any = document.getElementById('iframeGeoPortal')

    SessionStorageService.setItem("valoresResumo", seletedOcorrenciaReulst);

    iframe.contentWindow?.postMessage(
      { type: 'SiarlOcorrenciasCenter', value: [ocorrencia.id] },
      '*'
    )
    if (ocorrencia.oc_ocorrencia_apoio_id) {
      iframe.contentWindow?.postMessage(
        {
          type: 'SiarlOcorrenciasApoioSearch',
          value: [ocorrencia.oc_ocorrencia_apoio_id],
        },
        '*'
      )
    }

    iframe.contentWindow?.postMessage(
      { type: 'SiarlOcorrenciasHighlightRemove', value: [ocorrencia.id] },
      '*'
    )

    // iframe.contentWindow?.postMessage(
    //   { type: 'SiarlOcorrenciasCenter', value: [ocorrencia.id] },
    //   '*'
    // )


    SessionStorageService.setItem("novaOcorrencia", 'false')
    SessionStorageService.setItem('ocorrenciaAntiga', 'true')
    sessionStorage.setItem('ocGeomEdited', 'false')


    selectOcorrenciaResultId(ocorrencia.id as number)
    selectOcorrenciaResult(seletedOcorrenciaReulst)
    setOcorrenciaSelected(seletedOcorrenciaReulst);

    setShowResults(false)
    if (setShowOcorrenciaForm) setShowOcorrenciaForm(true)

    if (ocorrencia.coord_x && ocorrencia.coord_y) {
      setCoordenadasSelected(ocorrencia.coord_x + ', ' + ocorrencia.coord_y)
    } else {
      setCoordenadasSelected(undefined)
    }

    restoreView();

  }

  const handlePageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent
    const take = event.page.take

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value)
    }

    setPage2({
      ...event.page,
      take,
    })
    
  }

  const CommandCell = (props: GridCellProps) => (
    <ResultadoOcorrenciaCommandGridCell
      {...props}
      onLocationClick={handleLocationClickById}
      onInfoClick={handleInfoClickById}
      onLocationMouseEnter={handleRowMouseEnterById}
      onLocationMouseLeave={handleRowMouseLeaveById}
    />
  )

  const DocumentCommandCell = (props: GridCellProps) => (
    <ResultadoDocumentoCommandGridCell
      {...props}
      onLocationClick={handleLocationClickById}
      onInfoClick={handleInfoClickById}
      onDocumentPreviewClick={handleDocumentPreviewClickById}
      onLocationMouseEnter={handleRowMouseEnterById}
      onLocationMouseLeave={handleRowMouseLeaveById}
    />
  )

  const documentosToPreview = documentosOcorrencias

  const handleDocumentPreviewClickById = (documentosLocal: Record<string, any>) => async () => {

    try {

      postMessage({ type: "showLoader" }, "*");
      const documentos = await getDocumento(documentosLocal.id);

      setIdDoDocumento(documentosLocal.id);
      setUrlDoDocumento(documentos.url);
      setOpenFormViewDocumento(true);

    } catch (error) {
      handleGenericError(error, "Não foi possivel abrir o documento!")
      setOpenFormViewDocumento(false);

    } finally {

      postMessage({ type: "hideLoader" }, "*");

    }
  }

  const nextPhoto = async (e: any) => {

    try{

      postMessage({ type: "showLoader" }, "*");
      const nextIds = documentosToPreview
        .filter((doc: any) => doc.id < idDoDocumento && doc.url !== '')
        .map((doc: any) => doc.id);
  
      if (nextIds.length > 0) {
        const nextId = Math.max(...nextIds);
        console.log(`O próximo ID é ${nextId}`);
  
        const documento = await getDocumento(nextId);
  
        setIdDoDocumento(nextId.toString());
        setUrlDoDocumento(documento.url);

        const iframe: any = document.getElementById('iframeGeoPortal')
        const idOcorrencia = documento.ocorrencia_id;
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlOcorrenciasCenter',
            value: [idOcorrencia],
          },
          '*'
        )
  
      } else {
        console.log("Não há um próximo ID na lista.");
      }

    }catch(error){

      handleGenericError(error, "Não foi possivel abrir o documento!")

    }finally{

      postMessage({ type: "hideLoader" }, "*");

      e.preventDefault();
    }
   
  }

  const previousPhoto = async (e: any) => {

    try{

      postMessage({ type: "showLoader" }, "*");
      const previousIds = documentosToPreview
        .filter((doc: any) => doc.id > idDoDocumento && doc.url !== '')
        .map((doc: any) => doc.id);
  
      if (previousIds.length > 0) {
        const previousId = Math.min(...previousIds);
        console.log(`O anterior ID é ${previousId}`);
  
        const documento = await getDocumento(previousId);
  
        setIdDoDocumento(previousId.toString());
        setUrlDoDocumento(documento.url);

        const iframe: any = document.getElementById('iframeGeoPortal')
        const idOcorrencia = documento.ocorrencia_id;
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlOcorrenciasCenter',
            value: [idOcorrencia],
          },
          '*'
        )
        restoreView();

      } else {
        console.log("Não há um anterior ID na lista.");
      }

    }catch(error){

      handleGenericError(error, "Não foi possivel abrir o documento!")

    }finally{

      postMessage({ type: "hideLoader" }, "*");

      e.preventDefault();
    }
       
  }

  useEffect(() => {

    const elemento: any = document.querySelector(".k-window-content.k-dialog-content");

    if (elemento) {
      elemento.style.padding = "0px";
    }

  }, [openForm]);

  const previewDocument: any = (e: any) => {
    console.log(e);
  }

  const CustomCell = (props: GridCellProps) => (
    <CustomGridCell
      {...props}
      onMouseEnter={handleRowMouseEnterById}
      onMouseLeave={handleRowMouseLeaveById}
    />
  )

  const [selected, setSelected] = useState<number>(0)

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected)
    selectTab = e.selected
    if (selectTab == REGISTOS) {
      setShowExportButtons(true)
    } else if (selectTab == DOCUMENTOS) {
      setShowExportButtons(false)
    }
  }

  const enterEdit = (item: any) => {
    console.log(item)
    return
  }

  const pointOnMap = (item: any) => {
    console.log(item)
    return
  }
  const openFileDoc = (item: any) => {
    console.log(item)
    return
  }
  const openDocument = (item: any) => {
    console.log(item)
    return
  }

  useEffect(() => {
    if (ocorrencias) console.log({ ocorrencias })
  }, [ocorrencias])

  const onItemClick = (event: any) => {
    if (hasPermission(PERMISSION_CONSULTAR_OCORRENCIA) || hasPermission(PERMISSION_OCORRENCIA_PERFIL_COMPLETO_EDICAO) ||
  hasPermission(PERMISSION_OCORRENCIA_PERFIL_INTERMEDIO_EDICAO)) {
    const link: HTMLAnchorElement | null = document.querySelector('#print-results');

    if (link) {
      link.click();
    }

    } else {
      const link: HTMLAnchorElement | null = document.querySelector('#print-results-simples');

    if (link) {
      link.click();
    }
  }

    // if (event.item.key == 'ExportarFichasResultados') {

      

    // } else if (event.item.key == 'ExportarListaResultados') {

    //   console.log(event.item.text);

    // }

  };

  const ColumnMenu = (dataState: any) => {
    let datafilter;
    if(selectTab == 1){
      datafilter = documentosOcorrenciasFilter;
    }else{
      datafilter = ocorrenciasDataFilter;
    }
    return (
      <div>
      {/* <GridColumnMenuSort {...dataState} /> */}
      {/* <GridColumnMenuFilter {...dataState} /> */}
      {/* <GridColumnMenuGroup {...dataState} /> */}
      <GridColumnMenuCheckboxFilter {...dataState} data={datafilter} expanded={true} />
    </div>)

  }

  const options = [
    {
      key: 'ExportarFichasResultados',
      text: 'Fichas',
    },
    {
      key: 'ExportarListaResultados',
      text: 'Resultados',
    },
  ]

  const itemRender = (props: { item: any; itemIndex: number }) => {
    const isTitleItem = props.item.key === 'titulo';
    if (isTitleItem) {
      // Item de título personalizado
      return (
        <div className={styles.DropDownButtonTitulo}>
          <span>{props.item.text}</span>
        </div>
      );
    } else {
      // Demais itens
      return (
        <div className={styles.DropDownButtonItem}>
          <span>{props.item.text}</span>
        </div>
      );
    }
  };

  const closePreview = () => {
    setOpenFormViewDocumento(false);
  }

  const [columsDocuments, setColumsDocuments] = useState<{ columns: {field?:string, title?:string, width?:number|string, show:boolean, columnMenu?:any, filter?:any}[] }>({
    columns: [
      { field: "id", title: "ID", filter: 'numeric', columnMenu: ColumnMenu, show: true ,width: 90},
      { field: "ocorrencia_id", title: "Id Ocorrência", filter: 'numeric', columnMenu: ColumnMenu, show: true ,width: 170},
      { field: "dataPublicacaoFormatted", title: "Data de publicação", columnMenu: ColumnMenu, show: true ,  width: 220},
      { field: "tipoRecurso.designacao", title: "Tipo de Recurso", columnMenu: ColumnMenu, show: true ,  width: 190},
      { field: "titulo", title: "Título", columnMenu: ColumnMenu, show: true ,  width: 170},
      { field: "autores", title: "Autor", columnMenu: ColumnMenu, show: true ,  width: 170},
      { field: "entidade.nome", title: "Entidade", columnMenu: ColumnMenu, show: true ,  width: 200},
      { field: "primarioDescription", width: 180, title: "Primário", show: true },
    ]
  })

  const [columsAvancada, setColumsAvancada]=useState<{columns:{field?:string, title?:string, width?:number|string, show:boolean, columnMenu?:any, filter?:any}[]}>({
    columns:[
      { field: "id",filter:'text', title: "ID", show: true,  columnMenu: ColumnMenu, width: 90},
      { field: "data_ocorrencia",filter:'text', title: "Data Ocorrência",  columnMenu: ColumnMenu,show: false,  width: 210 },
      { field: "data_registo", filter:'text',title: "Data Registo",  columnMenu: ColumnMenu, show: true, width: 170},
      { field: "filedoc_cod", filter:'text',title: "Nº Processo APA",  columnMenu: ColumnMenu, show: false, width: 170},
      { field: "localizacao_concat",filter:'text', title: "Localização", columnMenu: ColumnMenu,show: true, width: 170 },
      // { field: "tipologia",filter:'text', title: "Tipologia", columnMenu: ColumnMenu, show: true , width: 170},
      // { field: "consequencias",filter:'text', title: "Consequências", columnMenu: ColumnMenu, show: false , width: 290},
      { field: "entidade",filter:'text', title: "Entidade", columnMenu: ColumnMenu, show: true , width: 200},
      { field: "tecnico",filter:'text', title: "Técnico de registo", columnMenu: ColumnMenu, show: false , width: 220},
      { field: "nuts1",filter:'text', title: "NUTS I", columnMenu: ColumnMenu, show: false, width: 270 },  
      { field: "nuts2",filter:'text', title: "NUTS II", columnMenu: ColumnMenu, show: false, width: 270 },  
      { field: "nuts3",filter:'text', title: "NUTS III", columnMenu: ColumnMenu, show: false, width: 270 },  
      { field: "distrito",filter:'text', title: "Distrito", columnMenu: ColumnMenu, show: false, width: 270 },  
      { field: "concelho",filter:'text', title: "Concelho", columnMenu: ColumnMenu, show: false, width: 270 },  
      { field: "freguesia",filter:'text', title: "Freguesia", columnMenu: ColumnMenu, show: false, width: 270 },  
      { field: "arh",filter:'text', title: "ARH", columnMenu: ColumnMenu, show: false, width: 270 },  
      { field: "massaAgua",filter:'text', title: "Massa de água", columnMenu: ColumnMenu, show: false, width: 270 },  
      { field: "praia",filter:'text', title: "Praia", columnMenu: ColumnMenu, show: false, width: 270 },  
      { field: "designacao_tipo_detecao",filter:'text', title: "Deteção da ocorrência", columnMenu: ColumnMenu, show: false , width: 225},
      { field: "estado_ocorrencia",filter:'text', title: "Estado", columnMenu: ColumnMenu, show: false, width: 170 },  
      { field: "descricao_tip_mmv",filter:'text', title: "Movimento de massa de vertente (MMV)", columnMenu: ColumnMenu, show: false, width: 250 },  
      { field: "tip_fenda_visivel_descricao",filter:'text', title: "Fenda de tração com abertura visível", columnMenu: ColumnMenu, show: false, width: 250 },  
      { field: "tip_erosao_arribas_descricao",filter:'text', title: "Erosão/recuo da linha de costa", columnMenu: ColumnMenu, show: false, width: 320 },  
      { field: "tip_escarpamento_duna_descricao",filter:'text', title: "Escarpamento da duna", columnMenu: ColumnMenu, show: false, width: 250 },  
      { field: "tip_rebaixamento_praia_descricao",filter:'text', title: "Rebaixamento da praia", columnMenu: ColumnMenu, show: false, width: 260 },  
      { field: "galgamento_costeiro_descr",filter:'text', title: "Galgamento costeiro", columnMenu: ColumnMenu, show: false, width: 300 },  
      { field: "dano_obra",filter:'text', title: "Danos em estruturas de proteção/defesa costeira", columnMenu: ColumnMenu, show: false, width: 400 },  
      { field: "dano_estrutura_aderente",filter:'text', title: "Estrutura aderente", columnMenu: ColumnMenu, show: false, width: 280 },  
      { field: "dano_esporao",filter:'text', title: "Esporão/Quebra-Mar", columnMenu: ColumnMenu, show: false, width: 270 },  
      { field: "dano_estrutura_protecao",filter:'text', title: "Estrutura de proteção/estabilização de arriba", columnMenu: ColumnMenu, show: false, width: 380 },  
      { field: "inst_arribas",filter:'text', title: "Instabilidade em arribas", columnMenu: ColumnMenu, show: false, width: 170 },  
      { field: "alcance_mmv",filter:'text', title: "Alcance máximo do depósito/detritos (m)", columnMenu: ColumnMenu, show: false, width: 400 },  
      { field: "alcance_escarpamento_duna",filter:'text', title: "Altura máxima da escarpa (m)", columnMenu: ColumnMenu, show: false, width: 340 },  
      { field: "alcance_rebaixamento_praia",filter:'text', title: "Altura máxima do rebaixamento da praia (m)", columnMenu: ColumnMenu, show: false, width: 320 },  
      { field: "alcance_galgamento_costeiro",filter:'text', title: "Alcance máximo de água/detritos (m)", columnMenu: ColumnMenu, show: false, width: 320 },  
      { field: "tipo_pessoas_risco_descricao",filter:'text', title: "Pessoas em risco", columnMenu: ColumnMenu, show: false, width: 230 },  
      { field: "num_pessoas_em_risco",filter:'text', title: "Número de pessoas em risco", columnMenu: ColumnMenu, show: false, width: 230 },  
      { field: "conseq_danos_areas_construidas_descricao",filter:'text', title: "Danos em áreas construídas de fruição/uso público", columnMenu: ColumnMenu, show: false, width: 420 },  
      { field: "danos_edificacoes_descricao",filter:'text', title: "Danos em Edifícios", columnMenu: ColumnMenu, show: false, width: 230 },  
      { field: "conseq_danos_outras_descricao",filter:'text', title: "Outros Danos", columnMenu: ColumnMenu, show: false, width: 230 },  
      { field: "conseq_danos_outras_obs",filter:'text', title: "Descrição outros danos", columnMenu: ColumnMenu, show: false, width: 230 },  
      { field: "tipo_danos_sistemas_naturais_descricao",filter:'text', title: "Danos em sistemas naturais", columnMenu: ColumnMenu, show: false, width: 260 },  
      { field: "danos_sistemas_naturais_obs",filter:'text', title: "Danos em sistemas naturais descrição", columnMenu: ColumnMenu, show: false, width: 320 },  
      { field: "causas_nao_sabe_descricao",filter:'text', title: "Causas não sabe/não aplicável", columnMenu: ColumnMenu, show: false, width: 290 },  
      { field: "causas_tempestade_descricao",filter:'text', title: "Causas Tempestade", columnMenu: ColumnMenu, show: false, width: 220 },  
      { field: "causas_tempestade_obs",filter:'text', title: "Causas tempestade observações", columnMenu: ColumnMenu, show: false, width: 270 },  
      { field: "causas_sistemos_descricao",filter:'text', title: "Causas sismos", columnMenu: ColumnMenu, show: false, width: 220 },  
      { field: "causas_outras_descricao",filter:'text', title: "Causas outras", columnMenu: ColumnMenu, show: false, width: 220 },  
      { field: "causas_ouras_obs",filter:'text', title: "Causas outras descrição", columnMenu: ColumnMenu, show: false, width: 270 },  
      { field: "tipo_medida_mitigacao_descricao",filter:'text', title: "Medidas mitigação de risco", columnMenu: ColumnMenu, show: false, width: 270 },  
      { field: "longitude",filter:'text', title: "Longitude (ETRS89/PT-TM06)", columnMenu: ColumnMenu, show: false, width: 270 }, 
      { field: "latitude",filter:'text', title: "Latitude (ETRS89/PT-TM06)", columnMenu: ColumnMenu, show: false, width: 270 }, 
      { field: "mitig_sinalizacao_descricao",filter:'text', title: "Mitigação sinalização", columnMenu: ColumnMenu, show: false, width: 270 }, 
      { field: "mitig_delimitacao_descricao",filter:'text', title: "Mitigação delimitação", columnMenu: ColumnMenu, show: false, width: 270 }, 
      { field: "mitig_saneamento_descricao",filter:'text', title: "Mitigação saneamento", columnMenu: ColumnMenu, show: false, width: 270 }, 
      { field: "mitig_reabilitacao_descricao",filter:'text', title: "Mitigação reabilitação", columnMenu: ColumnMenu, show: false, width: 270 }, 
      { field: "mitig_reforco_descricao", filter:'text', title: "Mitigação reforço", columnMenu: ColumnMenu, show: false, width: 270 },
    ]
  })

  const columnsAvancadaOrdered = {columns: columsAvancada.columns.slice().sort((a: any, b: any) => a.title.localeCompare(b.title))} 

    const [columsInicio, setColumsInicio]=useState<{columns:{field?:string, title?:string, width?:number|string, show:boolean, columnMenu?:any, filter?:any}[]}>({
    columns:[
      { field: "id", title: "ID",filter:'text', show: true,  columnMenu: ColumnMenu},
      { field: "data_ocorrencia",filter:'text', title: "Data Ocorrência",  columnMenu: ColumnMenu,show: true },
      { field: "localizacao_concat",filter:'text', title: "Localização", columnMenu: ColumnMenu,show: true },
      { field: "tip_erosao_arribas_descricao",filter:'text', title: "Erosão/recuo da linha de costa", columnMenu: ColumnMenu, show: false, width: 320 },  
      { field: "dano_obra",filter:'text', title: "Danos em estruturas de proteção/defesa costeira", columnMenu: ColumnMenu, show: false, width: 400 },  
      { field: "inst_arribas",filter:'text', title: "Instabilidade em arribas", columnMenu: ColumnMenu, show: false, width: 170 },  
    ]
  })

  const [columns, setColumns] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsOcorrencias');
    return storedValue ?? columnsAvancadaOrdered;
  });

  const [columnsGrid, setColumnsGrid] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsOcorrenciasGrid');
    return storedValue ?? columsAvancada;
  });

  useEffect(() => {
    SessionStorageService.setItem(keyPainelDocumentos, JSON.stringify(columsDocuments));
  }, [columsDocuments]);
  
  useEffect(() => {
    SessionStorageService.setItem(keyPainelPrincipal, JSON.stringify(columns));
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
      { type: 'SiarlDefineExtraLayerTooltipColumns', value:{  layer: OCORRENCIA_POINT_NAME,  columns: columns?.columns?.filter((x: { show: any; }) => x.show).map((option: { field: any; title: any; }) => ({
     field: option.field,
     title: option.title
   })) } },
      '*'
    )
  }, [columns]);

   useEffect(() => {
    if (hasPermission(PERMISSION_CONSULTAR_OCORRENCIA) ||
      hasPermission(PERMISSION_OCORRENCIA_PERFIL_COMPLETO_EDICAO) ||
      hasPermission(PERMISSION_OCORRENCIA_PERFIL_COMPLETO_LEITURA) ||
      hasPermission(PERMISSION_OCORRENCIA_PERFIL_TOTAL)) {
      if (!SessionStorageService.getItem("columnsOcorrencias")) {
        setColumns(columnsAvancadaOrdered);
        setColumnsGrid(columsAvancada);
      } 
    }else {
      setColumns(columsInicio);
      setColumnsGrid(columsInicio);
    }
  }, [])

  useEffect(() => {
    SessionStorageService.setItem("columnsOcorrenciasGrid", columnsGrid)
  }, [columnsGrid])

  useEffect(() => {
    SessionStorageService.setItem("columnsOcorrencias", columns);
    updateColumnsGrid(columns, columnsGrid, setColumnsGrid);
    
  }, [columns])



  useLayoutEffect(() => {

    const handleResize = () => {

      if (window.innerWidth <= telaMobile) {
        
        setIsMobile(true);
        ocultaFloatingMenu_e_Mapa();

      }else{

        setIsMobile(false);
        mostraFloatingMenu_e_Mapa();

      }

      if (window.innerWidth <= 1350) {
        setIsSmallerThan1350(true);
      }else{
        setIsSmallerThan1350(false);
      }

      if (window.innerWidth <= 1120) {
        setIsSmallerThan1120(true);
      }else{
        setIsSmallerThan1120(false);
      }

      if (window.innerWidth <= 850) {
        setIsSmallerThan850(true);
      }else{
        setIsSmallerThan850(false);
      }

    };
    
  
    window.addEventListener('resize', handleResize);
  
    handleResize();
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);  





  //ITEMS MOBILE
  const onItemClickMais = async (event: any) => {

    elementoClickMais(event);

    if (event.item.key == 'novoRegisto') {

      mostraFloatingMenu_e_Mapa();

    }

    if(event.item.key == "ExportarTodasFichas"){
      onItemClickExportarFichas();
    }

    if (event.item.key == 'ExportarListaResultadosExcel') {

      exportExcel();

    }
    else if (event.item.key == 'ExportarListaResultadosCsv'){
      const link: HTMLAnchorElement | null = document.querySelector('#print-results');

      if (link) {
        link.click();
      }
    }
    else if (event.item.key == "ExportarListaResultadosPdf") {
      exportPDFDownload();
    }
    else if (event.item.key == "ExportarListaResultadosShapeFile") {
      const results = JSON.parse(
        SessionStorageService.getItem('resultadoOcorrenciasPesquisa') ?? ''
      )
  
      if (results) {
        const iframe: any = document.getElementById('iframeGeoPortal')
        const ids: number[] = []
        results.forEach((element: any) => {
          ids.push(element.id)
        })

        const columnsToExport = columns.columns.filter((x: { show: any; }) => x.show).map((x: { field: any; }) => x.field);
        const ocorrenciasFiltred: any[] = [];
        ocorrencias?.forEach((item: any) => {
          const filteredItem: any[] = [];
          columns.columns.filter((x: { show: any; }) => x.show).forEach((column: any) => {
            filteredItem.push({
              Key: column.field,
              Value: item[column.field]?.toString()
            });
          });
          ocorrenciasFiltred.push(filteredItem);
      })

        const objToSend = {
          ids: ids,
          fields: columnsToExport,
          values: ocorrenciasFiltred
        }

        const file: any = await getShapeFile(objToSend);
        const filePath = `siarl-lista-ocorrencias-${format(new Date(), 'ddMMyyyHHmm')}.zip`;

       handleDownload(file, filePath);
    } 
  
  }

  };
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  function handleButtonClick() {
    setIsOpen(!isOpen);
  }
  const optionsMais = () => {
    function filterCallback(value: any, item: any, setColumnsFunction: any, currentColumns: any[]) {
      const columnsUpdate = currentColumns.map((column: any) => {
        // to avoid the bad behaviour of the key title, must be reimplemented the itemRenderMais function
        const itemKey = item.key === "title" ? "titulo" : item.key

        if (column.field === itemKey) {
          return { ...column, show: value.value };
        } else {
          return column;
        }
      });
    
      const checkedColumns = columnsUpdate.filter((column: any) => column.show);
      if (checkedColumns.length === 0 && !value.value) {
        // Si es la única columna marcada y está siendo desmarcada, no hacer nada
        return;
      }
    
      setColumnsFunction({ columns: columnsUpdate });      
    }

    let columnsItems
    
    if (selected === 0) {
      columnsItems = columns?.columns?.map((c: any) => ({
        key: c.field,
        text: c.title,
        checked: c.show,
        elementType: "filterButton",
        filterCallback: (value: any, item: any) => filterCallback(value, item, setColumns, columns.columns)
      }));
    } else {
      columnsItems = columsDocuments?.columns?.map((c: any) => ({
        // to avoid the bad behaviour of the key title, must be reimplemented the itemRenderMais function
        key: c.field === "titulo" ? "title" : c.field,
        text: c.title,
        checked: c.show,
        elementType: "filterButton",
        filterCallback: (value: any, item: any) => filterCallback(value, item, setColumsDocuments, columsDocuments.columns)
      }));
    }



    return [
      {
        key: 'titulo',
        text: 'Imprimir',
      },
      {
        key: 'imprimirFicha',
        text: 'Resultados',
        className: 'icon-siarl icon-imprimir btnIconRegistar'
      },
      {
        key: 'titulo',
        text: 'Exportar',
      },
      {
        key: 'ExportarListaResultadosExcel',
        text: 'excel',
      },
      {
        key: 'ExportarListaResultadosCsv',
        text: 'CSV',
      },
      // {
      //   key: 'ExportarListaResultadosPdf',
      //   text: 'PDF',
      // },
      {
        key: 'ExportarTodasFichas',
        text: 'Fichas',
      },
      {
        key: 'ExportarListaResultadosShapeFile',
        text: 'Shapefile',
      },
      {
        key: 'titulo',
        text: 'Colunas da tabela',
      },
      
      ...columnsItems,
    ]
  }

  const optionsExportarPerfilTotal = [
    {
      key: 'ExportarListaResultadosExcel',
      text: 'excel',
    },
    {
      key: 'ExportarListaResultadosCsv',
      text: 'CSV Listagem',
    },
    {
        key: 'ExportarListaResultadosCsvTotal',
        text: 'CSV Total',
    },
    // {
    //   key: 'ExportarListaResultadosPdf',
    //   text: 'PDF',
    // },
    {
      key: 'ExportarListaResultadosShapeFile',
      text: 'Shapefile',
    },
    {
      key: 'ExportarTodasFichas',
      text: 'Fichas',
    },
  ]
   
  const optionsExportarNormal = [
    {
      key: 'ExportarListaResultadosExcel',
      text: 'excel',
    },
    {
      key: 'ExportarListaResultadosCsv',
      text: 'CSV Listagem',
    },
    // {
    //   key: 'ExportarListaResultadosPdf',
    //   text: 'PDF',
    // },
    {
      key: 'ExportarListaResultadosShapeFile',
      text: 'Shapefile',
    },
    {
      key: 'ExportarTodasFichas',
      text: 'Fichas',
    },
  ]

let _export: any;
const exportExcel = () => {
  _export.save();
};

let _pdfExport: any;
const exportPDFDownload = () => {
   _pdfExport.save();
 };

const onItemClickExportarFichas = async () => {
  try {

  
    
    const relatorios = [];

    const results = JSON.parse(
      SessionStorageService.getItem('resultadoOcorrenciasPesquisa') ?? ''
    );
  
    const idsOcorrencias = results.map((o: any) => o.id);

    if(idsOcorrencias.length  > RECORDS_LIMIT){
      postMessage({ type: 'errorMsg', value: { message: "Não é possivel exportar mais de 100 fíchas" } }, '*')
      return false
      } 

      const resultOcorrencias = await getOcorrenciasPorIds(idsOcorrencias);
      postMessage({ type: 'showLoader' }, '*');
    
      for (const ocorrencia of resultOcorrencias) {
        
        let email = '';
        if (ocorrencia?.utilizador_id) {
          email = await getEmailByUserId(ocorrencia?.utilizador_id)
        }
        let instabilidadeArribaText = ""
        let movimentoMassaText = ""
        const alcanceMaximoDepositotext = ": Alcance máximo do depósito/detritos: " + (ocorrencia?.tip_mmv_alcance_deposito ? ocorrencia?.tip_mmv_alcance_deposito.toString() : '') + "m\n"
        let fendaTracaoText = ""
        let erosaoRecuoText = ""
        let escarpamentoText = ""
        const alturaMaxEscarpamentoText = ": Altura máxima da escarpa: " + (ocorrencia?.tip_altura_maxima_escarpa ? ocorrencia?.tip_altura_maxima_escarpa.toString() : ' ')  + "m\n"
        let rebaixamentoText = "" 
        const alturaMaxPraiaText = ":  Altura máxima da praia: " + (ocorrencia?.tip_reb_praia_altura_max ? ocorrencia?.tip_reb_praia_altura_max.toString() : ' ') + 'm\n';
        let galgamentoCosteiroText = ""
        const alcanceMaximoAguaText = " : Alcance máximo de água /detritos: " + (ocorrencia?.tip_galg_cost_alcance_max ? ocorrencia?.tip_galg_cost_alcance_max.toString() : '') + 'm\n'
        let protecaoDefesaText = ""
        let estruturaAderenteText = ""
        let esporaoText = ""
        let estruturaProtecaoText = ""
        let pessoasEmRiscoText = ""
        let danosEdificaoesText = ""
        let danosUsoPublico = ""
        let outrosDanosText = ""
        const descricaoOutrosDanosText = ocorrencia?.conseq_danos_outras_obs ? ocorrencia?.conseq_danos_outras_obs.toString() : ''
        let sistemasNaturaisText = ""
        const descricaoSistemasNaturaisText = ocorrencia?.danos_sistemas_naturais_obs ? ocorrencia?.danos_sistemas_naturais_obs.toString() : ''
        let naoSabeText = ""
        let tempestadeText = ""
        const descricaoTempestadeText = (ocorrencia?.causas_tempestade_obs ? ocorrencia?.causas_tempestade_obs.toString() : '') + '\n'
        let sismosText = ""
        let outrasText = ""
        const descricaoOutrasText = ocorrencia?.causas_ouras_obs ? ocorrencia?.causas_ouras_obs.toString() : '';
        let medidasMetigacaoText = ""
    
        if(ocorrencia?.tip_inst_arribas == true){
          instabilidadeArribaText = "Instabilidades em arribas\n";
       }
       if(ocorrencia?.tip_mmv == true){
          movimentoMassaText = "    Movimento de massa de vertente (MMV)" + alcanceMaximoDepositotext 
       }
       if(ocorrencia?.tip_fenda_visivel == true){
          fendaTracaoText = "    Fenda tração com cobertura visível\n"
       }
       if(ocorrencia?.tip_erosao_arribas == true){
         erosaoRecuoText = "Erosão/Recuo da linha da costa\n"
       }
       if(ocorrencia?.tip_escarpamento_duna == true){
         escarpamentoText = "    Escarpamento da duna" + alturaMaxEscarpamentoText
       }
       if(ocorrencia?.tip_rebaixamento_praia == true){
         rebaixamentoText = "    Rebaixamento da praia" + alturaMaxPraiaText
       }
       if(ocorrencia?.galgamento_costeiro == true) {
         galgamentoCosteiroText = "Galgamento costeiro " + alcanceMaximoAguaText
       }
       if(ocorrencia?.tip_dano_obra == true){
         protecaoDefesaText = "Danos em estruturas de proteção/defesa costeira\n"
       }
       if(ocorrencia?.tip_dano_estrutura_aderente == true){
         estruturaAderenteText = "Estrutura aderente\n"
       }
       if(ocorrencia?.tip_dano_esporao == true){
         esporaoText = "Esporão/Quebra-Mar"
       }
       if(ocorrencia?.tip_dano_estrutura_protecao == true){
        estruturaProtecaoText = "\nEstrutura de proteção/estabilização de arriba"
       }
       if(ocorrencia?.tipo_pessoas_risco_id == 1){
         pessoasEmRiscoText = "Sim"
       }
       else if(ocorrencia?.tipo_pessoas_risco_id == 2){
         pessoasEmRiscoText = "Não  sabe/Não Aplicável"
       }
       else if(ocorrencia?.tipo_pessoas_risco_id == 0 || ocorrencia?.tipo_pessoas_risco_id == undefined){
         pessoasEmRiscoText = "Não"
       }
  
  
       
       if(ocorrencia?.conseq_danos_areas_construidas == true){
        danosUsoPublico = "Danos em áreas construidas de fruição/uso público\n"
      }
       if(ocorrencia?.conseq_danos_edificacoes == true){
         danosEdificaoesText = "Danos em edifícios\n"
       }
       if(ocorrencia?.conseq_danos_outras == true){
         outrosDanosText = "Outros danos: " + descricaoOutrosDanosText
       }
       if(ocorrencia?.tipo_danos_sistemas_naturais_id == 1){
         sistemasNaturaisText = "Sim: " + descricaoSistemasNaturaisText
       }
       if(ocorrencia?.tipo_danos_sistemas_naturais_id == 2){
         sistemasNaturaisText = "Não sabe/Não Aplicável"
       }
       if(ocorrencia?.tipo_danos_sistemas_naturais_id == 0 || ocorrencia?.tipo_danos_sistemas_naturais_id == undefined){
         sistemasNaturaisText = "Não"
       }
  
       if(ocorrencia.causas_nao_sabe == true){
        naoSabeText = "• Não sabe/Não Aplicável\n"
      }
       if(ocorrencia.causas_tempestade == true){
        tempestadeText = "• Tempestade: " + descricaoTempestadeText
      }
       if(ocorrencia?.causas_sistemos == true){
        sismosText = "• Sismos\n"
      }
       if(ocorrencia?.causas_outras == true){
        outrasText = "• Outras: " + descricaoOutrasText
      }
  
       if(ocorrencia?.tipo_medida_mitigacao_id == 2){
         medidasMetigacaoText = "Não sabe/Não Aplicável"
       }
       if(ocorrencia?.tipo_medida_mitigacao_id == 1){
         medidasMetigacaoText ="Sim"
       }
       if(ocorrencia?.tipo_medida_mitigacao_id == 0 || ocorrencia.medidasMetigacao == undefined){
         medidasMetigacaoText = "Não"
       }
    
       const entidade = ocorrencia?.entidade ?? '';
    
        let tipologiaOcorrenciaText = instabilidadeArribaText + movimentoMassaText + fendaTracaoText + erosaoRecuoText
         + escarpamentoText + rebaixamentoText + galgamentoCosteiroText + protecaoDefesaText + estruturaAderenteText + esporaoText + estruturaProtecaoText
    
         if (tipologiaOcorrenciaText == "") {
          tipologiaOcorrenciaText = "-";
          }
    
        let danosEdificacoesText = danosUsoPublico + danosEdificaoesText + outrosDanosText
        
        if(danosEdificacoesText == ""){
            danosEdificacoesText = "-";
          }
    
        let causasOcorrenciaText = naoSabeText + tempestadeText + sismosText + outrasText
    
        if (causasOcorrenciaText == "") {
          causasOcorrenciaText = "-";
          }
          let obs = ""
          if(ocorrencia?.observacoes == ""){
             obs = "-"
          }
          else{
            obs = ocorrencia?.observacoes 
          }
  
          let longitudeLatitude = '';
        if (ocorrencia.coord_x && ocorrencia.coord_y) {
          const latLong = proj4(EPSG_MAP, EPSG_OCORRENCIA_DISPLAY, [ocorrencia.coord_x,ocorrencia.coord_y]);
          let latitude = 0;
          let longitude = 0;
          if (latLong && latLong.length > 0) {
            longitude= latLong[0].toFixed(0);
            latitude = latLong[1].toFixed(0);
          }
          longitudeLatitude = longitude + " , " + latitude
        }
  
          let detecaoOcorrencia = '';
  
          if(ocorrencia.tipo_detecao_id == 1){
            detecaoOcorrencia = "Aviso/Chamada"
          }
          else{
            detecaoOcorrencia = "Visita Regular"
            
          }

        let sinalizacaoImediataText = '';
        let delimitacaoImediataText = '';
        let saneamentoImediataText = '';
        let reabilitacaoImediataText = '';
        let reforcoImediataText = '';
        if(ocorrencia?.mitig_sinalizacao == 2 ){
         sinalizacaoImediataText = "Sinalização aviso\n"
        }
        if(ocorrencia?.mitig_delimitacao == 2){
         delimitacaoImediataText = "Delimitação da área de risco\n"
        }
        if(ocorrencia?.mitig_saneamento == 2){
         saneamentoImediataText = "Saneamento de blocos\n"
        }
        if(ocorrencia?.mitig_reabilitacao == 2){
         reabilitacaoImediataText = "Reabilitação de obra de proteção\n"
        }
        if(ocorrencia?.mitig_reforco == 2){
         reforcoImediataText = "Reforço artificial de emergência\n"
        }

        const medidasMetigacaoImediataText = sinalizacaoImediataText + delimitacaoImediataText + saneamentoImediataText + reabilitacaoImediataText + reforcoImediataText;

         
        let sinalizacaoAdotarText = '';
        let delimitacaoAdotarText = '';
        let saneamentoAdotaraText = '';
        let reabilitacaoAdotarText = '';
        let reforcoAdotarText = '';

        if(ocorrencia?.mitig_sinalizacao == 1 ){
         sinalizacaoAdotarText = "Sinalização aviso\n"
        }
        if(ocorrencia?.mitig_delimitacao == 1){
         delimitacaoAdotarText = "Delimitação da área de risco\n"
        }
        if(ocorrencia?.mitig_saneamento == 1){
         saneamentoAdotaraText = "Saneamento de blocos\n"
        }
        if(ocorrencia?.mitig_reabilitacao == 1){
         reabilitacaoAdotarText = "Reabilitação de obra de proteção\n"
        }
        if(ocorrencia?.mitig_reforco == 1){
         reforcoAdotarText = "Reforço artificial de emergência\n"
        }

        const medidasMetigacaoAdotarText = sinalizacaoAdotarText + delimitacaoAdotarText + saneamentoAdotaraText + reabilitacaoAdotarText + reforcoAdotarText;

        const objToSendImgMapa : any = {
          CodPrintTemplate: "RELATORIO_OCORRENCIAS2",
          extendInfo: {
            spatialReference: {
              wkid: 0
            },
            xmin: 0,
            ymin: 0,
            xmax: 0,
            ymax: 0
          },
          ListOperationalLayerInfo: [
            {
              IdOperationLayer: OPERATIONAL_LAYER,
              UseLayerExtent: false,
              DefinitionExpression: "",
              ListServiceLayer: [
                {
                    LayerId: LAYER_INDEX_OCORRENCIAS,
                    DefinitionExpression: "id=" + ocorrencia.id,
                    UseLayerExtent: ocorrencia.oc_ocorrencia_apoio_id ? false : true
                },
                {
                    LayerId: LAYER_INDEX_OCORRENCIA_APOIO,
                    DefinitionExpression: "ocorrencia_id=" + ocorrencia.id,
                    UseLayerExtent: ocorrencia.oc_ocorrencia_apoio_id ? true : false
                }
              ]
            }
          ]
        }


 
      const relatorio = {
        Id: ocorrencia.id,
        dados: {
          'REGISTO' : '',
          'Data do registo:': ocorrencia?.data_registo ? new Date(ocorrencia?.data_registo).toLocaleDateString() : '',
          'Técnico:': ocorrencia?.tecnico ?? '',
          'Email:' :  email ?? '',
          'Entidade:': entidade ?? '',
 
         'IDENTIFICAÇÃO' : '',
          'Data da ocorrência:': ocorrencia?.data_ocorrencia ? new Date(ocorrencia?.data_ocorrencia).toLocaleDateString() : 'Data indeterminada',
          'Deteção da ocorrência:': detecaoOcorrencia,
 
         'LOCALIZAÇÃO' : '',
          'Concelho:': ocorrencia?.concelho ?? '',
          'ARH :': ocorrencia?.arh ?? '',
          'Capitania:': ocorrencia?.capitania ?? '',
          'Praia:': ocorrencia?.praia ?? '',
          'Referência de local:': ocorrencia?.ref_localizacao ?? '',
          '(ETRS89 TM06, EPSG: 3763) Longitude, latitude:':  longitudeLatitude ? longitudeLatitude + ' (ETRS89/PT-TM06)' : '',
         
          'TIPOLOGIA DA OCORRÊNCIA' : '',
          'Tipologia da Ocorrência:': tipologiaOcorrenciaText ?? '',
      
          'CONSEQUÊNCIAS DA OCORRÊNCIA' : '',
          'Pessoas em risco:': pessoasEmRiscoText ?? '',
          'Danos em edificações:': danosEdificacoesText ?? '',
            
          'Danos em sistemas:': sistemasNaturaisText ?? '',
 
           'CAUSAS DA OCORRÊNCIA' : '',
          'Causas da ocorrência:': causasOcorrenciaText ?? '',

          'MEDIDAS DE MITIGAÇÃO DE RISCO' : '',
          'Medidas de mitigação do risco:' : medidasMetigacaoText ?? '',
          'Medidas emediatas:' : medidasMetigacaoImediataText == "" ? "-" : medidasMetigacaoImediataText ,
          'Medidas a adotar:' : medidasMetigacaoAdotarText == "" ? "-" : medidasMetigacaoAdotarText ,

          'OBSERVAÇÕES' : '',
          'Observação:': obs ?? '',

        },
        img_mapa: " ",
        objJsonToCreateImg: objToSendImgMapa

      };
      
      relatorios.push(relatorio);
  }

    const mergedPdfBase64 = await relatorioOcorrenciasMerge(relatorios);
    if (mergedPdfBase64) {
      const blob = b64toBlob(mergedPdfBase64, 'application/pdf');
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    }
  } catch (error) {
    console.log(error);
    postMessage({ type: 'errorMsg', value: { left: '50%', message: "Verifique os campos obrigatórios." } }, '*');
  } finally {
    postMessage({ type: 'hideLoader' }, '*');
  }
};



  const onItemClickExportar = async (event: any) => {

    if(event.item.key == "ExportarTodasFichas"){
      onItemClickExportarFichas();
    }

    if (event.item.key == 'ExportarListaResultadosExcel') {

      exportExcel();

    }
    else if (event.item.key == 'ExportarListaResultadosCsv'){
      const link: HTMLAnchorElement | null = document.querySelector('#print-results');

      if (link) {
        link.click();
      }
    }
    else if (event.item.key == 'ExportarListaResultadosCsvTotal') {
      const objToSearch = SessionStorageService.getItem("lastSearchOcorrenciasAvancada");
      postMessage({ type: 'showLoader' }, '*');
      const result: any = await getOcorrenciasToExport(objToSearch);
      exportToCSV(result, 'Ocorrencias', ';');
      postMessage({ type: 'hideLoader' }, '*');
    }

    else if (event.item.key == "ExportarListaResultadosPdf") {
      exportPDFDownload();
    }
    else if (event.item.key == "ExportarListaResultadosShapeFile") {
      const results = JSON.parse(
        SessionStorageService.getItem('resultadoOcorrenciasPesquisa') ?? ''
      )
  
      if (results) {
        const iframe: any = document.getElementById('iframeGeoPortal')
        const ids: number[] = []
        results.forEach((element: any) => {
          ids.push(element.id)
        })

        const columnsToExport = columns.columns.filter((x: { show: any; }) => x.show).map((x: { field: any; }) => x.field);
        const ocorrenciasFiltred: any[] = [];
        ocorrencias?.forEach((item: any) => {
          const filteredItem: any[] = [];
          columns.columns.filter((x: { show: any; }) => x.show).forEach((column: any) => {
            filteredItem.push({
              Key: column.field,
              Value: item[column.field]?.toString()
            });
          });
          ocorrenciasFiltred.push(filteredItem);
      })

        const objToSend = {
          ids: ids,
          fields: columnsToExport,
          values: ocorrenciasFiltred
        }

        const file: any = await getShapeFile(objToSend);
        const filePath = `siarl-lista-ocorrencias-${format(new Date(), 'ddMMyyyHHmm')}.zip`;

       handleDownload(file, filePath);
    } 
  
  }
};

useEffect(() => {
  const results = JSON.parse(
    SessionStorageService.getItem('resultadoOcorrenciasPesquisa') ?? ''
  )
  if (results && results.length == searchLimit) {
    postMessage({type:"errorMsg", value: {message: "Não é possível listar mais de " + searchLimit + " registos."}});
  }
}, [])

const onItemClickImprimir = async (event: any) => {
  openPdfNewTab();
}

const openAjuda = () => {
  if (SessionStorageService.getItem("ocorrenciasPesquisaTipo")) {
    const ocorrenciasPesquisaTipo = SessionStorageService.getItem("ocorrenciasPesquisaTipo");
    if (ocorrenciasPesquisaTipo == "Simples") {
      window.open(URL_AJUDA_OCORRENCIA_PESQUISA_SIMPLES, "_blank");
    } else if (ocorrenciasPesquisaTipo == "Avancada") {
      window.open(URL_AJUDA_OCORRENCIA_PESQUISA_AVANCADA, "_blank");
    }
  }
}
const availableOcorrencias = ocorrencias.slice();
const initialOcorrencias = availableOcorrencias.splice(0, 20);

const [gridData, setGridData] = React.useState(initialOcorrencias);

const scrollHandler = (event: { nativeEvent: any; }) => {
  const ScroolLength = 10;
  const e = event.nativeEvent;
  if (
    e.target.scrollTop + ScroolLength >=
    e.target.scrollHeight - e.target.clientHeight
  ) {
    const moreData = availableOcorrencias.splice(0, ScroolLength);
    if (moreData.length > 0) {
      setGridData((oldData) => oldData.concat(moreData));
    }
  }
};

const canCreateNewOcurrence = hasPermission(PERMISSION_INSERIR_OCORRENCIA) ||
hasPermission(PERMISSION_OCORRENCIA_PERFIL_TOTAL) ||
hasPermission(PERMISSION_OCORRENCIA_PERFIL_INTERMEDIO_EDICAO) ||
hasPermission(PERMISSION_OCORRENCIA_PERFIL_COMPLETO_EDICAO)

const PageTemplate = (props: any) => (
  <div className="page-template">
     <div className="header" style={{ display: 'flex', marginBottom: '-25px' , justifyContent: 'space-between', alignItems: 'center', fontSize: '10px', padding: '10px' }}>
    
     <div>
       <img style={{ width: '128px', height: 'auto', marginLeft: '2px' }} src={base64SiarlImage} alt="SIARL Logo" />
     </div>
     <div style={{ textAlign: 'right' }}>
       <span style={{ fontSize: '18px', color: '#1ba49c' }}>PESQUISA DE OCORRÊNCIAS</span>
     </div>
   </div>
   <div className="footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '10px' }}>
      
     <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
       <img style={{ width: '105px', marginBottom: '-25px' }} src={base64ApaImage} alt="APA Logo" />
       <img style={{ width: '280px', height: 'auto', marginBottom: '-25px' }} src={base64FooterImages} alt="Footer Image" />
     </div>
    
     <div style={{ flex: 1, textAlign: 'right', marginBottom: '-25px' }}>
      Data : {format(new Date(), "dd/MM/yyyy")} | Página {props.pageNum} de {props.totalPages}
     </div>
   </div>
 </div>
);


return (
  <div className={clsx(styles.base, isCurrentViewMaximized && commonStyles.maximizedBaseForm)}>
    <div className={styles.header}>
      <div>
        <div className={styles.nomeDoModulo}>Ocorrências</div>
        <div className={styles.tituloDaPagina}>Resultados de pesquisa</div>
      </div>

      <div style={{display: "flex", height: "fit-content", flexDirection: isSmallerThan850 ? "column-reverse" : "row"}}>
        <CSVLink
          title="Imprimir resultados"
          id="print-results"
          data={ocorrencias?.map((item: any) => {
            const filteredItem: any = {};
            columns.columns.filter((x: { show: any; }) => x.show).forEach((column: any) => {
                filteredItem[column.field] = item[column.field];
            });
            return filteredItem;
        })}
          separator=';'
          filename={`siarl-lista-ocorrencias-${format(new Date(), 'ddMMyyyHHmm')}`}
          hidden
        ></CSVLink>

        <CSVLink
          title="Imprimir resultados"
          id="print-results-simples"
          data={ocorrencias?.map((ocorrencia: any) => ({
            id: ocorrencia?.id,
            data_ocorrencia: ocorrencia?.data_ocorrencia,
            ref_localizacao: ocorrencia?.ref_localizacao,
            tipologia: ocorrencia?.tipologia
          }))}
          separator=';'
          filename={`siarl-lista-ocorrencias-${format(new Date(), 'ddMMyyyHHmm')}`}
          hidden
        ></CSVLink>
        <>
          <div className={styles.espacamentoBotoesResponsive}style={{marginBottom: "8px"}}>
            {isSmallerThan1120 && showExportButtons ? 
            <div ref={dropdownRef}>
              <DropDownButton
                items={optionsMais()}
                className={styles.btnMais}
                iconClass="icon-siarl icon-mais"
                onItemClick={onItemClickMais}
                fillMode={'flat'}
                itemRender={itemRenderMais}
                title="Mais Opções"
                opened={isOpen}
                onOpen={handleButtonClick}
              />
            </div>
             
            :
              <>
                {canCreateNewOcurrence && (
                  <button onClick={registarNovoClick} className={styles.btnNovoRegisto} style={isSmallerThan1350 ? {width: "38px", height: "38px"} : {}} id='novoRegisto' title='Nova ocorrência'>
                    <span className="icon-siarl icon-registar btnIconRegistar"/>
                      {!isSmallerThan1350 && <span>&nbsp;{' '}Nova ocorrência</span> }
                  </button>
                )}
                {showExportButtons ?
                <><VisualizadorColunas
                    columns={columns}
                    setColumns={setColumns}
                    styles={styles.btnEditar} />
                    
                    <button className={styles.btnEditar} onClick={exportPDFDownload} style={{ display: isMobile ? 'none' : '' }} id='imprimirFicha' title='Imprimir'>
                      <span className="icon-siarl icon-imprimir"></span>
                    </button></>
                    
                    : ''}
              </>
            }
            {!isSmallerThan1120 && showExportButtons ?(
              <div ref={dropdownRef}>
                <DropDownButton
                  items={optionsExportar}
                  className={styles.btnImprimir}
                  iconClass="icon-siarl icon-exportar"
                  onItemClick={onItemClickExportar}
                  fillMode={'flat'}
                  itemRender={itemRender}
                  title='Exportar'
                  opened={isOpen}
                  onOpen={handleButtonClick}
                ></DropDownButton>
              </div>
            )
            : '' } 
            {canCreateNewOcurrence && isSmallerThan1120 && (
                  <button onClick={registarNovoClick} className={styles.btnNovoRegisto} style={isSmallerThan1350 ? {width: "38px", height: "38px"} : {}} id='novoRegisto' title='Nova ocorrência'>
                    <span className="icon-siarl icon-registar btnIconRegistar"/>
                      {!isSmallerThan1120 && <span>&nbsp;{' '}Nova ocorrência</span> }
                  </button>
            )}
            
          </div>

          <div className={styles.espacamentoBotoesResponsive}> 
          <button onClick={openAjuda} className={styles.btnInfo} title="Obter Ajuda">
              <span className="icon-siarl icon-ajuda"></span>
            </button>           
            <button className={styles.btnFechar} onClick={onCloseClick} title="Minimizar">
              <span className="icon-siarl icon-minimizar"></span>
            </button>
            
            {!isMobile ? 
              <MaximizeButton className={styles.btnMaximizar} />
            : ''}
          </div>
        </>
      </div>
    </div>
{hasPermission(PERMISSION_CONSULTAR_OCORRENCIA) ||
      hasPermission(PERMISSION_OCORRENCIA_PERFIL_COMPLETO_EDICAO) ||
      hasPermission(PERMISSION_OCORRENCIA_PERFIL_COMPLETO_LEITURA) ||
      hasPermission(PERMISSION_OCORRENCIA_PERFIL_INTERMEDIO_EDICAO) ||
      hasPermission(PERMISSION_OCORRENCIA_PERFIL_INTERMEDIO_LEITURA) ||
      hasPermission(PERMISSION_OCORRENCIA_PERFIL_TOTAL) ?
    <TabStrip selected={selected} onSelect={handleSelect} scrollable={isMobile}>
      <TabStripTab title="Ocorrências">
        <ExcelExport
            fileName={`siarl-lista-ocorrencias-${format(new Date(), 'ddMMyyyHHmm')}`}
            data={ocorrencias}
            ref={(exporter) => {
              _export = exporter
            }}
          >
            <Grid
              className={styles.form}
              sortable={true}
              filterable={false}
              onDataStateChange={dataStateChange}
              data={
                dataResult.data.length > 0 
                  ? dataResult
                  : ocorrencias.map((documentosocorrencias: any) => ({
                      ...documentosocorrencias,  
              })).slice(page2.skip, page2.take + page2.skip)}
                
              {...dataState}
              pageable={{
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
              }}
              skip={page2.skip}
              take={page2.take}
              sort={sort.sort}
              total={dataResult.total != 0 ? dataResult.total : ocorrencias.length}
              cells={{ data: CustomCell }}
              onScroll={scrollHandler}
              fixedScroll={true}
            >
              <GridColumn cell={CommandCell} width={56} />

              {
              columnsGrid?.columns?.map((column: { show: any; field: string | undefined; columnMenu: React.ComponentType<GridColumnMenuProps> | undefined; width: string | number | undefined; title: string | undefined; }, i: React.Key | null | undefined) => {
                return (
                  column.show && (
                    <GridColumn key={i} field={column.field} columnMenu={column.columnMenu} width={column.width} title={column.title}  />
                  )
                );
              })}
            </Grid>
        </ExcelExport>

        <GridPDFExport
          fileName={`siarl-lista-ocorrencias-${format(new Date(), 'ddMMyyyHHmm')}`}
          ref={(element) => {
            _pdfExport = element
          }}
          paperSize="A4"
          margin={{ top: '3cm', right: '1cm', bottom: '2cm', left: '1cm' }}
          landscape={true}
          pageTemplate={PageTemplate} 
          repeatHeaders={true}

        >
                 {
              <Grid
                sortable={true}
                 data={ocorrencias}                
                pageable={{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: true,
                  previousNext: true,
                }}
                style={{ borderSpacing: '0' }} 
                //groupable={true}
              >
                {columnsGrid?.columns?.map((column: any, i: any) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} filter={column.filter} width={column.width} title={column.title} columnMenu={column.columnMenu}
                headerCell={() => <div className="pdf-header">{column.title}</div>}
                cell={(props: any) => (
                  <td style={{ fontSize: '10px', wordBreak: 'break-word', padding: '5px', border: '1px solid #1ba49c' , lineHeight: '1.3' }}>
                    {props.dataItem[column.field]}
                  </td>
                )}
                />
              )
            );
          })}
              </Grid>
            }
          </GridPDFExport>
      </TabStripTab>

      <TabStripTab title="Documentos">
        <ExcelExport
        fileName={`siarl-lista-documentos-ocorrencias-${format(new Date(), 'ddMMyyyHHmm')}`}
          data={documentosOcorrencias}
          ref={(exporter) => {
            _export = exporter
          }}
        >
            
            <Grid
              className={styles.form}
              sortable={true}
              filterable={false}
              onDataStateChange={dataStateChangeDocumentos}
              data={
                dataResultDocumentos.data.length > 0 
                  ? dataResultDocumentos
                  : documentosOcorrencias.map((documentos: any) => ({
                      ...documentos,
                      data_publicacao: documentos?.data_publicacao ? format(new Date(documentos.data_publicacao), 'dd/MM/yyyy HH:mm') : undefined,
              })).slice(page.skip, page.take + page.skip)
            }       
            {...dataStateDocumentos} 
                pageable={{
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
              }}
              skip={page.skip}
              take={page.take}
              sort={sortDocumentos.sort}
              total={dataResultDocumentos.total != 0 ? dataResultDocumentos.total : documentosOcorrencias.length }
              //onPageChange={handlePageChange}
              ////groupable={true}
              cells={{ data: CustomCell }}
            >
            
              <GridColumn cell={DocumentCommandCell} width={86} />
              {columsDocuments?.columns?.map((column, i) => {
                return (
                  column.show && (
                    <GridColumn key={i}  field={column.field} columnMenu={column.columnMenu}   width={column.width} title={column.title} />
                  )
                );
              })}
            </Grid>
        </ExcelExport>
      </TabStripTab>
    </TabStrip>
     :         <><ExcelExport
        fileName={`siarl-lista-ocorrencias-${format(new Date(), 'ddMMyyyHHmm')}`}
        data={ocorrencias}
        ref={(exporter) => {
          _export = exporter;
        } }
      >
        <Grid
          className={styles.form}
          sortable={true}
          filterable={false}
          onDataStateChange={dataStateChange}
          data={
                dataResult.data.length > 0 
                  ? dataResult
                  : ocorrencias.map((documentosocorrencias: any) => ({
                      ...documentosocorrencias,  
              })).slice(page2.skip, page2.take + page2.skip)}
          {...dataState}
          pageable={{
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
              }}
              skip={page2.skip}
              take={page2.take}
              sort={sort.sort}
              total={dataResult.total != 0 ? dataResult.total : ocorrencias.length}
          // //groupable={true}
          cells={{ data: CustomCell }}
        >
          <GridColumn cell={CommandCell} width={56} />

          {columns?.columns?.map((column: { show: any; field: string | undefined; columnMenu: React.ComponentType<GridColumnMenuProps> | undefined; width: string | number | undefined; title: string | undefined; }, i: React.Key | null | undefined) => {
            return (
              column.show && (
                <GridColumn key={i} field={column.field} columnMenu={column.columnMenu} width={column.width} title={column.title} />
              )
            );
          })}
        </Grid>
      </ExcelExport>
      <GridPDFExport
        fileName={`siarl-lista-ocorrencias-${format(new Date(), 'ddMMyyyHHmm')}`}
        ref={(element) => {
          _pdfExport = element;
        } }
        paperSize={['340mm', '297mm']}

        margin="1cm"
      >
          <Grid
            className={styles.form}
            sortable={true}
            filterable={false}
            onDataStateChange={dataStateChange}
            data={dataResult.data.length > 0 ? dataResult : ocorrencias}
            {...dataState}
            pageable={{
              buttonCount: 5,
              info: true,
              type: 'numeric',
              pageSizes: true,
              previousNext: true,
            }}
            total={dataResult.total != 0 ? dataResult.total : ocorrencias.length}
            // //groupable={true}
            cells={{ data: CustomCell }}
          >
            <GridColumn cell={CommandCell} width={56} />

            {columns?.columns?.map((column: { show: any; field: string | undefined; columnMenu: React.ComponentType<GridColumnMenuProps> | undefined; width: string | number | undefined; title: string | undefined; }, i: React.Key | null | undefined) => {
              return (
                column.show && (
                  <GridColumn key={i} field={column.field} columnMenu={column.columnMenu} width={column.width} title={column.title} />
                )
              );
            })}
          </Grid>
        </GridPDFExport></>
 }
    <div
      className={clsx(styles.footer, styles.justify_one_child, isCurrentViewMaximized && commonStyles.maximizedFooter)}
    >
      <Button className={styles.btnPesquisar} onClick={clearSearchResults} title='Nova Pesquisa'>
        <span className="icon-siarl icon-pesquisar"></span>
        <span className={styles.rotulo}>
          {' '}&nbsp;{' '}
          Nova pesquisa
        </span>
      </Button>
    </div>
    {openFormViewDocumento && (
        <Dialog
        className="ModalDocumentos"
          title={`Documento: ${idDoDocumento}`}
          onClose={closePreview}
          style={{ zIndex: 999 }}
        >
          
            <ImagePreviewV2
              documentUrl={urlDoDocumento}
              next={(e: any) => nextPhoto(e)}
              previous={(e: any) => previousPhoto(e)}
            />

        </Dialog>
      )}
  </div>
  
)
}
